import { useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Round 16 A26 -- a verb that takes something away asks first.
 *
 * Withdrawing a covering document was one click: no question, and a
 * verb ("Does not cover it") that read as a judgement about the
 * document rather than the act it performs. The first press opens the
 * question; only the second writes. One component, so the drawer and
 * the gap report cannot drift into asking different things.
 */
export function ConfirmedVerb({
  label,
  prompt,
  confirmLabel,
  onConfirm,
  disabled = false,
  testId,
}: {
  label: string;
  prompt: string;
  confirmLabel: string;
  onConfirm: () => void;
  disabled?: boolean;
  testId: string;
}): JSX.Element {
  const { t } = useTranslation();
  const [asking, setAsking] = useState(false);
  if (!asking) {
    return (
      <button
        type="button"
        data-testid={testId}
        disabled={disabled}
        onClick={() => setAsking(true)}
        className="text-[11px] text-slate-500 hover:text-rag-red hover:underline disabled:opacity-50"
      >
        {label}
      </button>
    );
  }
  return (
    <span data-testid={`${testId}-ask`} className="text-[11px] text-slate-700">
      {prompt}{" "}
      <button
        type="button"
        data-testid={`${testId}-confirm`}
        disabled={disabled}
        onClick={() => {
          setAsking(false);
          onConfirm();
        }}
        className="font-medium text-rag-red hover:underline disabled:opacity-50"
      >
        {confirmLabel}
      </button>
      {" · "}
      <button
        type="button"
        data-testid={`${testId}-cancel`}
        onClick={() => setAsking(false)}
        className="text-slate-500 hover:underline"
      >
        {t("common.cancel")}
      </button>
    </span>
  );
}
